var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index2"},[_c('div',{staticClass:"popup-overlay",on:{"click":_vm.closePopup}},[_c('div',{staticClass:"popup-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{staticClass:"popup-image",attrs:{"src":"https://ban.iot152.cn/images/guide.png","alt":"guide"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }